var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "input field js-input input--file",
      attrs: { value: "item.value" },
    },
    [
      _c(
        "input",
        _vm._g(
          {
            staticClass: "input__el clr-blue-22 trs js-input-el",
            attrs: {
              id: _vm.item.id,
              type: "file",
              placeholder: _vm.item.placeholder,
            },
            domProps: { value: _vm.value },
          },
          _vm.listeners
        )
      ),
      _c("span", { staticClass: "input__file-text trs" }, [
        _c("span", { staticClass: "media-obj input__icon" }, [
          _c("svg", { attrs: { xmlns: "http://www.w3.org/2000/svg" } }, [
            _c("use", {
              attrs: {
                href: "/local/templates/renaissance/layout/dist/assets/img/sprite.svg#i-file",
              },
            }),
          ]),
        ]),
        _vm.item.fileSelect == false
          ? _c("p", [_vm._v("Выберите файл")])
          : _vm._e(),
        _vm.item.fileSelect == true
          ? _c("p", [_vm._v(_vm._s(_vm.item.fileSelectName))])
          : _vm._e(),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }